import { motion } from "framer-motion";
import { useEffect, useState } from "react";

const HERO_IMG = "https://images.unsplash.com/photo-1526289034009-0240ddb68ce3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwxfHwzZCUyMGFic3RyYWN0JTIwZGFyayUyMGdsYXNzJTIwZ2VvbWV0cmljJTIwdGVjaHxlbnwwfHx8fDE3ODYzOTYxMjV8MA&ixlib=rb-4.1.0&q=85";

const lines = ["Sistemas que", "Impulsionam", "Negócios."];

const lineVariant = {
  hidden: { y: "110%" },
  show: (i) => ({ y: "0%", transition: { duration: 0.9, ease: [0.76, 0, 0.24, 1], delay: 0.3 + i * 0.12 } }),
};

export const Hero = () => {
  const [offset, setOffset] = useState(0);
  useEffect(() => {
    const on = () => setOffset(window.scrollY);
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);

  return (
    <section id="top" className="relative min-h-screen flex flex-col justify-end overflow-hidden pb-16 md:pb-24 pt-32">
      <div className="absolute inset-0 z-0" style={{ transform: `translateY(${offset * 0.35}px) scale(1.1)` }}>
        <img src={HERO_IMG} alt="" className="w-full h-full object-cover opacity-40" />
        <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/70 to-ink/30" />
        <div className="absolute inset-0 bg-gradient-to-r from-ink/80 to-transparent" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 w-full">
        <motion.div
          initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.15, duration: 0.6 }}
          className="flex items-center gap-3 mb-8">
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-acid">Soluções em Software</span>
        </motion.div>

        <h1 className="font-head font-black tracking-tighter leading-[0.9] text-5xl sm:text-7xl lg:text-8xl xl:text-[8.5rem]">
          {lines.map((line, i) => (
            <span key={i} className="block overflow-hidden">
              <motion.span custom={i} variants={lineVariant} initial="hidden" animate="show" className="block">
                {line === "Impulsionam" ? <span className="text-cobalt">{line}</span> : line}
              </motion.span>
            </span>
          ))}
        </h1>

        <motion.p
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.1, duration: 0.8 }}
          className="mt-8 max-w-xl text-lg md:text-xl text-white/60 leading-relaxed">
          Software robusto para PC, design imersivo e execução impecável.
          Da gestão ao PDV, construído sob medida para o seu negócio.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 1.3, duration: 0.6 }}
          className="mt-10 flex flex-col sm:flex-row gap-4">
          <a href="#recomendador" data-testid="hero-cta-recommender"
             className="group inline-flex items-center justify-center gap-3 bg-cobalt text-white px-8 py-4 font-mono text-xs uppercase tracking-[0.2em] hover:bg-white hover:text-ink transition-colors duration-300">
            Descobrir meu app ideal
            <span className="group-hover:translate-x-1 transition-transform duration-300">→</span>
          </a>
          <a href="#produtos" data-testid="hero-cta-products"
             className="inline-flex items-center justify-center px-8 py-4 border border-white/20 font-mono text-xs uppercase tracking-[0.2em] hover:border-white transition-colors duration-300">
            Ver a loja
          </a>
        </motion.div>
      </div>
    </section>
  );
};
